/**
 * Mapa mockup Stitch → ruta. Fuente: docs/plans/dashboard-ui-implementation.md §4.
 *
 * | ID Stitch (ej.) | Ruta |
 * | login_homeexpense, login_web_version | /login |
 * | registro_homeexpense | /register |
 * | recuperar_contrase_a | /forgot-password |
 * | cambiar_contrase_a | /reset-password, /settings/password |
 * | perfil_de_usuario | /settings/personal (datos); hub en /settings |
 * | mis_casas_*, casas_y_miembros_web_version | /houses, /houses/:houseId/members |
 * | home_dashboard, inicio_* | / |
 * | diario_*, journal_* | /houses/:houseId/expenses |
 * | filtros_de_gastos | query/modal (fase 4) |
 * | detalle_de_gasto_* | /houses/:houseId/expenses/:expenseId |
 * | confirmation_expense_paid | /houses/:houseId/expenses/:expenseId/paid-feedback |
 * | presupuesto_* | /houses/:houseId/budget |
 * | b_veda_*, registrar_nuevo_elemento_* | /houses/:houseId/vault, .../new, .../:itemId |
 * | escaneo_con_ia | /houses/:houseId/scan |
 */

export const dashboardPaths = {
  home: "/",
  login: "/login",
  register: "/register",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  settingsPassword: "/settings/password",
  settingsPasskeys: "/settings/passkeys",
  settingsPersonal: "/settings/personal",
  settingsProfile: "/settings/profile",
  settings: "/settings",
  /** Bandeja in-app (icono campana en el header). */
  notificationsInbox: "/notifications",
  /** Aceptar invitaciones a hogares sin ser aún miembro (enlace desde notificaciones). */
  pendingHouseInvitations: "/invitations/pending",
  /** Push, preferencias y dispositivos (desde perfil / ajustes). */
  settingsNotifications: "/settings/notifications",
  settingsDevices: "/settings/devices",
  support: "/support",
  /** Búsqueda global en la casa activa (gastos API + bóveda en cliente). */
  search: "/search",
  /** Asistente primera configuración (sin shell lateral). */
  onboarding: "/onboarding",
  houses: "/houses",
  houseMembers: (houseId: string) => `/houses/${houseId}/members`,
  houseExpenses: (houseId: string) => `/houses/${houseId}/expenses`,
  houseExpenseNew: (houseId: string) => `/houses/${houseId}/expenses/new`,
  houseExpenseDetail: (houseId: string, expenseId: string) =>
    `/houses/${houseId}/expenses/${expenseId}`,
  houseExpensePaidFeedback: (houseId: string, expenseId: string) =>
    `/houses/${houseId}/expenses/${expenseId}/paid-feedback`,
  houseExpenseSeries: (houseId: string, seriesId: string) =>
    `/houses/${houseId}/expense-series/${seriesId}`,
  houseBudget: (houseId: string) => `/houses/${houseId}/budget`,
  houseAnalytics: (houseId: string) => `/houses/${houseId}/analytics`,
  houseVault: (houseId: string) => `/houses/${houseId}/vault`,
  houseVaultNew: (houseId: string) => `/houses/${houseId}/vault/new`,
  houseVaultDetail: (houseId: string, itemId: string) => `/houses/${houseId}/vault/${itemId}`,
  houseScan: (houseId: string) => `/houses/${houseId}/scan`,
  houseFinancings: (houseId: string) => `/houses/${houseId}/financings`,
  houseFinancingNew: (houseId: string) => `/houses/${houseId}/financings/new`,
  houseFinancingDetail: (houseId: string, financingId: string) =>
    `/houses/${houseId}/financings/${financingId}`,
  houseFinancingEdit: (houseId: string, financingId: string) =>
    `/houses/${houseId}/financings/${financingId}/edit`,
} as const;
